import { api } from "./BackendService";

export const getById = (id) => api.get(`/cp/submissions/${id}`);
export const list = (page) => api.get("/cp/submissions", { params: { page } });
